import {
  resolveDoubtfulDescription,
  resolveIdDescriptor,
  resolveMinMax,
  resolveMinMaxDescription,
} from '../../../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    id,
    minId,
    maxId,
    day,
    month,
    minYear,
    maxYear,
    regionCode,
    causeCode,
    country,
    area,
    minLatitude,
    maxLatitude,
    minLongitude,
    maxLongitude,
    minEventValidity,
    maxEventValidity,
    minCauseCode,
    maxCauseCode,
    minEqMagnitude,
    maxEqMagnitude,
    oceanicTsunami,
    runupRegion,
    runupCountry,
    runupArea,
    runupMinDistance,
    runupMaxDistance,
    runupMinTravelTime,
    runupMaxTravelTime,
    minNumRunups,
    maxNumRunups,
    minMaxWaterHeight,
    maxMaxWaterHeight,
    minTroughHt,
    maxTroughHt,
    minRunupHoriz,
    maxRunupHoriz,
    minDeaths,
    maxDeaths,
    minDeathsAmountOrder,
    maxDeathsAmountOrder,
    minInjuries,
    maxInjuries,
    minInjuriesAmountOrder,
    maxInjuriesAmountOrder,
    minDamageMillionsDollars,
    maxDamageMillionsDollars,
    minDamageAmountOrder,
    maxDamageAmountOrder,
    minHousesDestroyed,
    maxHousesDestroyed,
    minHousesDestroyedAmountOrder,
    maxHousesDestroyedAmountOrder,
    minDeathsTotal,
    maxDeathsTotal,
    minDeathsAmountOrderTotal,
    maxDeathsAmountOrderTotal,
    minDamageMillionsDollarsTotal,
    maxDamageMillionsDollarsTotal,
    minDamageAmountOrderTotal,
    maxDamageAmountOrderTotal,
    runupMeasureType,
    runupDoubtful,
    runupMinHeight,
    runupMaxHeight,
    runupMinTroughHt,
    runupMaxTroughHt,
    runupMinDeaths,
    runupMaxDeaths,
    runupMinDeathsAmountOrder,
    runupMaxDeathsAmountOrder,
    runupMinInjuries,
    runupMaxInjuries,
    runupMinInjuriesAmountOrder,
    runupMaxInjuriesAmountOrder,
    runupMinDamageMillionsDollars,
    runupMaxDamageMillionsDollars,
    runupMinDamageAmountOrder,
    runupMaxDamageAmountOrder,
    runupMinHousesDestroyed,
    runupMaxHousesDestroyed,
    runupMinHousesDestroyedAmountOrder,
    runupMaxHousesDestroyedAmountOrder,
    locStart,
    locEnd,
    locInclude,
    locMatch,
    locNot,
    commentsStart,
    commentsEnd,
    commentsInclude,
    commentsMatch,
    commentsNot,
    runupLocStart,
    runupLocEnd,
    runupLocInclude,
    runupLocMatch,
    runupLocNot,
  },
  regions,
  runupRegions,
  peopleDescriptors,
  damageDescriptors,
  housesDescriptors,
  validities,
  causes,
  runupMeasurementTypes,
}) => {
  const messages = [];

  if (id != null) {
    messages.push(`ID = ${id}`);
  }

  resolveMinMax('ID', minId, maxId, messages);

  if (day != null) {
    messages.push(`Day = ${day}`);
  }

  if (month != null) {
    messages.push(`Month = ${month}`);
  }

  resolveMinMax('Year', minYear, maxYear, messages);

  if (regionCode != null) {
    const region = regionCode.split(',').map(s => resolveIdDescriptor(regions, s)).join(';');
    messages.push(`Region = ${region}`);
  }

  if (causeCode != null) {
    messages.push(`Cause Code = ${causeCode}`);
  }

  if (country != null) {
    messages.push(`Country = ${country}`);
  }

  if (area != null) {
    messages.push(`Area = ${area}`);
  }

  if (locStart != null) {
    messages.push(`Location starts with '${locStart}'`);
  }

  if (locMatch != null) {
    messages.push(`Location = '${locMatch}'`);
  }

  if (locInclude != null) {
    messages.push(`Location contains '${locInclude}'`);
  }

  if (locNot != null) {
    messages.push(`Location != '${locNot}'`);
  }

  if (locEnd != null) {
    messages.push(`Location ends with '${locEnd}'`);
  }

  if (oceanicTsunami != null) {
    messages.push(`Oceanic Tsunami = ${oceanicTsunami}`);
  }

  resolveMinMax('Latitude', minLatitude, maxLatitude, messages);
  resolveMinMax('Longitude', minLongitude, maxLongitude, messages);

  resolveMinMaxDescription('Validity', minEventValidity, maxEventValidity, validities, messages);

  resolveMinMaxDescription('Cause', minCauseCode, maxCauseCode, causes, messages);

  resolveMinMax('Deaths', minDeaths, maxDeaths, messages);
  resolveMinMaxDescription('Deaths Description', minDeathsAmountOrder, maxDeathsAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Injuries', minInjuries, maxInjuries, messages);
  resolveMinMaxDescription('Injuries Description', minInjuriesAmountOrder, maxInjuriesAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Houses Destroyed', minHousesDestroyed, maxHousesDestroyed, messages);
  resolveMinMaxDescription('Houses Destroyed Description', minHousesDestroyedAmountOrder, maxHousesDestroyedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Damage Millions $', minDamageMillionsDollars, maxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Damage Description', minDamageAmountOrder, maxDamageAmountOrder, damageDescriptors, messages);

  resolveMinMax('Total Deaths', minDeathsTotal, maxDeathsTotal, messages);
  resolveMinMaxDescription('Total Deaths Description', minDeathsAmountOrderTotal, maxDeathsAmountOrderTotal, peopleDescriptors, messages);

  resolveMinMax('Total Damage Millions $', minDamageMillionsDollarsTotal, maxDamageMillionsDollarsTotal, messages);
  resolveMinMaxDescription('Total Damage Description', minDamageAmountOrderTotal, maxDamageAmountOrderTotal, damageDescriptors, messages);

  resolveMinMax('Earthquake Magnitude', minEqMagnitude, maxEqMagnitude, messages);


  if (runupRegion != null) {
    const region = runupRegion.split(',').map(s => resolveIdDescriptor(runupRegions, s)).join(';');
    messages.push(`Runup Region = ${region}`);
  }

  if (runupCountry != null) {
    messages.push(`Runup Country = ${runupCountry}`);
  }

  if (runupArea != null) {
    messages.push(`Runup Area = ${runupArea}`);
  }

  if (runupLocStart != null) {
    messages.push(`Runup location starts with '${runupLocStart}'`);
  }

  if (runupLocMatch != null) {
    messages.push(`Runup Location = '${runupLocMatch}'`);
  }

  if (runupLocInclude != null) {
    messages.push(`Runup location contains '${runupLocInclude}'`);
  }

  if (runupLocNot != null) {
    messages.push(`Runup location != '${runupLocNot}'`);
  }

  if (runupLocEnd != null) {
    messages.push(`Runup location ends with '${runupLocEnd}'`);
  }

  if (runupMeasureType != null) {
    const measureType = runupMeasureType.split(',').map(s => resolveIdDescriptor(runupMeasurementTypes, s)).join(';');
    messages.push(`Measurement Type = ${measureType}`);
  }

  resolveMinMax('Runup Height', runupMinHeight, runupMaxHeight, messages);
  resolveMinMax('Runup Trough Height', runupMinTroughHt, runupMaxTroughHt, messages);

  resolveMinMax('Distance of Runup Location', runupMinDistance, runupMaxDistance, messages);
  resolveMinMax('Travel Time (Hours)', runupMinTravelTime, runupMaxTravelTime, messages);
  resolveMinMax('Number of Runups', minNumRunups, maxNumRunups, messages);
  resolveMinMax('Maximum Water Height', minMaxWaterHeight, maxMaxWaterHeight, messages);
  resolveMinMax('Maximum Trough Height', minTroughHt, maxTroughHt, messages);
  resolveMinMax('Maximum Inundation Distance', minRunupHoriz, maxRunupHoriz, messages);

  resolveMinMax('Runup Deaths', runupMinDeaths, runupMaxDeaths, messages);
  resolveMinMaxDescription('Runup Deaths Description', runupMinDeathsAmountOrder, runupMaxDeathsAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Runup Injuries', runupMinInjuries, runupMaxInjuries, messages);
  resolveMinMaxDescription('Runup Injuries Description', runupMinInjuriesAmountOrder, runupMaxInjuriesAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Runup Houses Destroyed', runupMinHousesDestroyed, runupMaxHousesDestroyed, messages);
  resolveMinMaxDescription('Runup Houses Destroyed Description', runupMinHousesDestroyedAmountOrder, runupMaxHousesDestroyedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Runup Damage Millions $', runupMinDamageMillionsDollars, runupMaxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Runup Damage Description', runupMinDamageAmountOrder, runupMaxDamageAmountOrder, damageDescriptors, messages);

  if (runupDoubtful != null) {
    const doubtfuls = runupDoubtful.split(',').map(s => resolveDoubtfulDescription(runupDoubtful, s)).join(';');
    messages.push(`Doubtfulness = ${doubtfuls}`);
    //
    // switch (d) {
    //   case 'n':
    //     messages.push('Doubtfulness = OK');
    //     break;
    //   case 'y':
    //     messages.push('Doubtfulness = Doubtful');
    //     break;
    //   case 'm':
    //     messages.push('Doubtfulness = Meteorological');
    //     break;
    //   case 'a':
    //     messages.push('Doubtfulness = Atmospheric');
    //     break;
    //   default:
    //     break;
    // }
  }

  if (commentsStart != null) {
    messages.push(`Comments start with '${commentsStart}'`);
  }

  if (commentsMatch != null) {
    messages.push(`Comments = '${commentsMatch}'`);
  }

  if (commentsInclude != null) {
    messages.push(`Comments contains '${commentsInclude}'`);
  }

  if (commentsNot != null) {
    messages.push(`Comments != '${commentsNot}'`);
  }

  if (commentsEnd != null) {
    messages.push(`Comments end with '${commentsEnd}'`);
  }

  return messages;
};
